import type { AdobePanelContext, ElectronContext } from '@mimir/common/context/applicationContext';
import type { AttachmentType } from '@mimir/common/dto/attachmentPrimitives';
import type { CreateItemAttachmentRequestDto } from '@mimir/common/dto/itemAttachmentDto';
import type { LimitedNodeApi } from '@mimir/common/nodejs/limitedNodeApi/nodeApi';
import type { BasicUploadManager } from '@mimir/common/upload/BasicUploadManager';
import { getLocalFileSize, waitForFileAccess } from '@mimir/common/util/fs';
import { api_createAttachmentToItem } from '../util/api';

const createUploadableFile = async (nodeApi: LimitedNodeApi, filePath: string) => {
  await waitForFileAccess(nodeApi, filePath, 5);
  return {
    name: filePath,
    size: getLocalFileSize(nodeApi, filePath),
    path: filePath,
  };
}

export const uploadAttachmentToItem = async (
  services: {
    applicationContext: AdobePanelContext | ElectronContext,
    uploadManager: BasicUploadManager,
  },
  filePath: string,
  itemId: string,
  attachmentCreateRequest: CreateItemAttachmentRequestDto,
  attachmentType: AttachmentType,
) => {
  const uploadManager = services.uploadManager;
  const uploadableFile = await createUploadableFile(services.applicationContext.nodeApi, filePath);
  await uploadManager.uploadAttachmentToItem(
    itemId, attachmentCreateRequest, uploadableFile,
    api_createAttachmentToItem,
    (p) => {
      console.debug(`Uploading ${attachmentType} attachment, progress: `, p);
    }
  );
}
